import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { CommonResponse } from 'models';
import { BarInfo } from './models/IBarGuideInfo';

// state class
export interface BarInfoState {
  loading: boolean;
  bar_infos: BarInfo[];
}

// init model state
const initialState: BarInfoState = {
  loading: false,
  bar_infos: [] as Array<BarInfo>,
};

// slice
const barInfoListSlice = createSlice({
  name: 'barInfoList',
  initialState,
  reducers: {
    fetchListOfBarInfo(state) {
      state.loading = true;
    },
    fetchListOfBarInfoSuccess(state, action: PayloadAction<CommonResponse<Array<BarInfo>>>) {
      state.bar_infos = action.payload.data;
      state.loading = false;
    },
    fetchListOfBarInfoFailed(state) {
      state.loading = false;
      state.bar_infos = [];
    },
    deleteBarInfo(state, action: PayloadAction<Array<number>>) {
      state.loading = true;
    },
    deleteBarInfoSuccess(state, action: PayloadAction<CommonResponse<Array<BarInfo>>>) {
      state.bar_infos = state.bar_infos.map((info) => ({
        ...info,
        delete_flg: action.payload.data.some((obj) => obj.id === info.id) ? true : info.delete_flg,
      }));
      state.loading = false;
    },
    deleteBarInfoFailed(state) {
      state.loading = false;
    },
    restoreBarInfo(state, action: PayloadAction<Array<number>>) {
      state.loading = true;
    },
    restoreBarInfoSuccess(state, action: PayloadAction<CommonResponse<Array<BarInfo>>>) {
      state.bar_infos = state.bar_infos.map((info) => ({
        ...info,
        delete_flg: action.payload.data.some((obj) => obj.id === info.id) ? false : info.delete_flg,
      }));
      state.loading = false;
    },
    restoreBarInfoFailed(state) {
      state.loading = false;
    },
    updateBarInfo(state, action: PayloadAction<BarInfo>) {
      state.loading = true;
    },
    updateBarInfoSuccess(state, action: PayloadAction<CommonResponse<Array<BarInfo>>>) {
      action.payload.data.forEach((objB) => {
        let index = state.bar_infos.findIndex((objA) => objA.id === objB.id);
        if (index !== -1) {
          state.bar_infos[index] = objB;
        }
      });
      state.loading = false;
    },
    updateBarInfoFailed(state) {
      state.loading = false;
    },
    addNewBarInfo(state, action: PayloadAction<BarInfo>) {
      state.loading = true;
    },
    addNewBarInfoSuccess(state, action: PayloadAction<CommonResponse<Array<BarInfo>>>) {
      state.bar_infos.push(...action.payload.data);
      state.loading = false;
    },
    addNewBarInfoFailed(state) {
      state.loading = false;
    },
  },
});

// Actions
export const barInfoListActions = barInfoListSlice.actions;

// Selectors
export const selectBarInfoList = (state: RootState) => state.barInfo.bar_infos;

// Reducer
export const barInfoListReducer = barInfoListSlice.reducer;
